import classNames from 'classnames';
import { forwardRef } from 'react';
import BreadcrumbItem from './BreadcrumbItem';
import BreadcrumbsWrapper from './style/BreadcrumbsWrapper';

const Breadcrumbs = forwardRef(({ items, className }, ref) => (
  <BreadcrumbsWrapper className={classNames('p--0 m--0', className)} ref={ref}>
    {items?.map(({ Icon, url, label, key }, index) => (
      <BreadcrumbItem Icon={Icon} url={url} label={label} key={key} lastElement={items.length - 1 !== index} />
    ))}
  </BreadcrumbsWrapper>
));
export default Breadcrumbs;
